import React from 'react'
import PropTypes from 'prop-types'

export function CustomerSyncExplanation(props) {
  const { integration, helpCenterLink } = props
  return (
    <React.Fragment>
      <p>Import contacts from your {integration} account as customers in Simplesat.</p>
      <p>Existing customers will be updated. New ones will be created.</p>
      <p>
        <a href={helpCenterLink} target="_blank" rel="noopener">
          <i className="icon far fa-book" />
          Learn more about syncing {integration} contacts
        </a>
      </p>
    </React.Fragment>
  )
}

CustomerSyncExplanation.propTypes = {
  integration: PropTypes.string.isRequired,
  helpCenterLink: PropTypes.string.isRequired,
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/CustomerSyncExplanation.js